export let hrms55xColumns = () => {
  let indexColumns = [{
    key: 'dtework',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '10',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '20',
    style: 'min-width: 200px;'
  }, {
  //   key: 'codshift',
  //   name: '',
  //   labelCodapp: 'HRMS55XC2',
  //   labelIndex: '40',
  //   class: 'align-center',
  //   style: 'min-width: 100px;'
  // }, {
  //   key: 'timinoutw',
  //   name: '',
  //   labelCodapp: 'HRMS55XC2',
  //   labelIndex: '50',
  //   class: 'align-center',
  //   style: 'min-width: 120px;'
  // }, {
    key: 'codleave',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codleave',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'timinoutl',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'qtyleave',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRMS55XC2',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms55x.js